import { Link, Text } from "@chakra-ui/react";
import { PRIVACY_URL, TERMS_URL } from "../legalLinks";

// Texto do aceite, com os links abrindo em outra aba para o usuário não perder o que
// já preencheu. Usado no cadastro e no modal de aceite.
export default function TermsConsentLabel() {
  return (
    <Text as="span" fontSize="sm">
      Li e aceito os{" "}
      <Link href={TERMS_URL} isExternal color="accent-text" fontWeight="semibold">
        Termos de Uso
      </Link>{" "}
      e a{" "}
      <Link href={PRIVACY_URL} isExternal color="accent-text" fontWeight="semibold">
        Política de Privacidade
      </Link>
      .
    </Text>
  );
}
